import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { Layout } from "./components/Layout";
import { ContaduriaPage } from "./pages/ContaduriaPage";
import { CompradorPage } from "./pages/CompradorPage";
import { RechazadasPage } from "./pages/RechazadasPage";
import { PosteoPage } from "./pages/PosteoPage";
import { FueraDeCarrilAPage } from "./pages/FueraDeCarrilAPage";
import { FacturasParaPagarPage } from "./pages/FacturasParaPagarPage";
import { ArchivadasPage } from "./pages/ArchivadasPage";
import { BuscarPage } from "./pages/BuscarPage";
import { AprobacionPagosPage } from "./pages/AprobacionPagosPage";
import { useRoles } from "./auth/useRoles";
import { ROLE_CONTADURIA, ROLE_COMPRADOR, ROLE_CONTROL_PAGOS, ROLE_APROBADOR_PAGOS } from "./constants/roles";
import { apiScopes } from "./auth/authConfig";
import { ContadoresProvider } from "./contexts/ContadoresContext";

function LoginScreen() {
  const { instance } = useMsal();
  return (
    <div className="login-screen">
      <h1>Bandeja de Facturas — Pontyn</h1>
      <button onClick={() => instance.loginRedirect({ scopes: apiScopes })}>
        Iniciar sesión con Microsoft
      </button>
    </div>
  );
}

function AppRoutes() {
  const roles = useRoles();
  // Se agrega una rama para el rol nuevo sin cambiar las dos que ya existian:
  // quien solo tiene ControlPagos no tiene nada que hacer en /comprador.
  const homeRoute = roles.includes(ROLE_CONTADURIA)
    ? "/contaduria"
    : roles.includes(ROLE_COMPRADOR)
      ? "/comprador"
      : roles.includes(ROLE_CONTROL_PAGOS)
        ? "/facturas-para-pagar"
        : // [NUEVO 04/11/2026] Rama al final: quien solo aprueba pagos no tiene nada en /comprador.
          roles.includes(ROLE_APROBADOR_PAGOS)
          ? "/aprobacion-pagos"
          : "/comprador";

  return (
    // ContadoresProvider envuelve al Layout porque el menú lateral (que vive
    // en Layout) muestra los badges de cantidad de cada bandeja.
    <ContadoresProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to={homeRoute} replace />} />
          <Route path="/contaduria" element={<ContaduriaPage />} />
          <Route path="/comprador" element={<CompradorPage />} />
          <Route path="/rechazadas" element={<RechazadasPage />} />
          <Route path="/posteo" element={<PosteoPage />} />
          <Route path="/fuera-de-carril-a" element={<FueraDeCarrilAPage />} />
          <Route path="/facturas-para-pagar" element={<FacturasParaPagarPage />} />
          {/* [NUEVAS 20/10/2026] Solo lectura. /buscar existe siempre como
              ruta, pero el link del menú aparece solo con el flag del backend
              prendido; apagado, el backend responde 404 a la búsqueda. */}
          <Route path="/archivadas" element={<ArchivadasPage />} />
          <Route path="/buscar" element={<BuscarPage />} />
          {/* [NUEVA 04/11/2026] Detrás del flag `lotes_pago`: apagado, la
              página muestra "No disponible" y no pide nada más. */}
          <Route path="/aprobacion-pagos" element={<AprobacionPagosPage />} />
        </Routes>
      </Layout>
    </ContadoresProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthenticatedTemplate>
        <AppRoutes />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginScreen />
      </UnauthenticatedTemplate>
    </BrowserRouter>
  );
}
